module.exports = __webpack_public_path__ + "img/facebook.47613a75.png";